<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.id"
                 placeholder="ID"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.nickname"
                 placeholder="用户昵称"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.referrerId"
                 placeholder="推荐人id"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.phone"
                 placeholder="请输入手机号"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.agentType"
                  :label-in-value="true"
                  placeholder="代理类型"
                  class="select"
          >
            <Option value="5" label="地推"></Option>
            <Option value="1" label="自主推广"></Option>
            <Option value="2" label="推广服务商"></Option>
            <Option value="3" label="区域合伙人"></Option>
            <Option value="4" label="城市代理"></Option>
          </Select>
        </div>
        <!-- 添加时间筛选 -->
        <div class="search-item">
          <DatePicker
              type="daterange"
              v-model="dateRange"
              placeholder="选择时间范围"
              style="width: 200px"
              @on-change="handleDateChange"
          ></DatePicker>
        </div>

        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            @click="exportDownLoad"
        >导出
        </Button>
      </div>
    </div>
    <div class="table">
      <Table
          :columns="diyData.columns"
          :data="apiData.tableList"
          @on-sort-change="handleSortChange"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>
    </div>

    <!-- 代理类型修改模态框 -->
    <Modal
        v-model="diyDom.showAgentTypeModal"
        title="修改代理类型"
        @on-ok="saveAgentType"
        @on-cancel="cancelAgentType"
    >
      <Form :model="agentTypeForm" :label-width="80">
        <FormItem label="代理类型">
          <Select v-model="agentTypeForm.agentType" placeholder="请选择代理类型">
            <Option v-for="item in agentTypeOptions" :key="item.value" :value="item.value">
              {{ item.label }}
            </Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { apiRecommendImgByUserId, apiUserinfoExport, apiUserinfoList, apiUpdateAgentType } from '@/api/user-manage.js'
import { getDateTime } from '@/libs/util'

export default {
  name: 'user-manage',
  data () {
    return {
      query: {},
      search: {
        nickname: '',
        referrerId: '',
        phone: '',
        agentType: '',
        id: '',
        pageNo: 1,
        pageSize: 10,
        orderNum: '',
        createTimeBegin: '', // 添加开始时间
        createTimeEnd: '' // 添加结束时间
      },
      diyDom: {
        showModal: false,
        showAgentTypeModal: false
      },
      agentTypeForm: {
        id: '',
        agentType: ''
      },
      agentTypeOptions: [
        { value: '5', label: '地推' },
        { value: '1', label: '自主推广' },
        { value: '2', label: '推广服务商' },
        { value: '3', label: '区域合伙人' },
        { value: '4', label: '城市代理' }
      ],
      referrerTotalSort: '', // 添加排序状态变量
      diyData: {
        orderNo: '',
        columns: [
          {
            title: '头像',
            width: '90px',
            render: (h, params) => {
              return h('img', {
                attrs: {
                  src: params.row.headImgUrl
                },
                style: {
                  width: '50px'
                }
              })
            }
          },
          {
            title: '昵称/ID',
            width: '150px',
            key: 'phone',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.realname || params.row.nickname || params.row.username),
                h('p', params.row.id)
              ])
            }
          },
          {
            title: '推荐人/ID',
            width: '140px',
            render: (h, params) => {
              return h('div', [
                h(
                  'div', // 改为 a 标签
                  {
                    style: {
                      color: '#2D8cF0',
                      cursor: 'pointer'
                    },
                    on: {
                      click: () => {
                        this.handleClickReferrerId(params.row.referrerId) // 绑定点击事件
                      }
                    }
                  },
                  params.row.referrerName
                ),
                h(
                  'div', // 改为 a 标签
                  {
                    style: {
                      color: '#2D8cF0',
                      cursor: 'pointer'
                    },
                    on: {
                      click: () => {
                        this.handleSearchReferrerId(params.row.referrerId) // 绑定点击事件
                      }
                    }
                  },
                  params.row.referrerId
                )
              ])
            }
          },
          {
            title: '手机号',
            width: '150px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.phone)
              ])
            }
          },
          {
            title: '当前积分',
            width: '120px',
            sortable: true,
            key: 'score'
          },

          {
            title: '推广总计',
            width: '120px',
            key: 'referrerTotal',
            sortable: true,
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: {
                      color: '#2D8cF0',
                      marginRight: '10px'
                    },
                    on: {
                      click: () => {
                        this.handleClickReferrerId(params.row.id) // 绑定点击事件
                      }
                    }
                  },
                  params.row.referrerTotal
                )
              ])
            }
          },
          {
            title: '代理类型',
            width: '100px',
            key: 'agentType',
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: {
                      color: '#2D8cF0',
                      cursor: 'pointer'
                      // textDecoration: 'underline'
                    },
                    on: {
                      click: () => {
                        this.showAgentTypeModal(params.row)
                      }
                    }
                  },
                  this.getAgentTypeText(params.row.agentType)
                )
              ])
            }
          },
          {
            title: 'IP&地区',
            width: '200px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.ip),
                h('p', params.row.ipRegion)
              ])
            }
          },
          {
            title: '注册时间',
            width: '200px',
            key: 'createTime'
          },
          {
            title: '最后登录时间',
            width: '200px',
            key: 'lastLoginTime'
          },
          {
            title: '操作',
            width: '300px',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      apiRecommendImgByUserId({
                        userId: params.row.id,
                        hebing: 0
                      }).then((res) => {
                        var imgUrl = res.data
                        window.open(imgUrl)
                      })
                    }
                  }
                },
                '推广二维码'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      sessionStorage.setItem('search', JSON.stringify(this.search))
                      this.$router.push({
                        name: 'points-details',
                        query: {
                          userId: params.row.id
                        }
                      })
                    }
                  }
                },
                '积分明细'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      sessionStorage.setItem('search', JSON.stringify(this.search))
                      this.$router.push({
                        name: 'order-records',
                        query: {
                          userId: params.row.id
                        }
                      })
                    }
                  }
                },
                '查看订单'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        infor: null,
        tableList: []
      },
      dateRange: [] // 添加时间范围数据
    }
  },
  methods: {
    // 分页
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    handleClickReferrerId (referrerId) {
      if (!referrerId) {
        this.$Message.warning('该用户没有推荐人')
        return
      }

      this.search.referrerId = referrerId // 设置推荐人 ID 为搜索条件
      this.search.pageNo = 1 // 重置页码为第一页
      this.getTableList() // 调用查询方法
    },
    handleSearchReferrerId (referrerId) {
      if (!referrerId) {
        this.$Message.warning('该用户没有推荐人')
        return
      }

      this.search.id = referrerId // 设置推荐人 ID 为搜索条件
      this.search.pageNo = 1 // 重置页码为第一页
      this.getTableList() // 调用查询方法
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList () {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search }
      opt.createTimeBegin = getDateTime(this.search.createTimeBegin)
      opt.createTimeEnd = getDateTime(this.search.createTimeEnd)
      apiUserinfoList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    exportDownLoad () {
      this.$store.commit('setSpinShow', true)
      console.log(11)
      apiUserinfoExport({ ...this.search }).then(res => {
        // this.diyDom.showExport = false
        const { data } = res
        const blob = new Blob([data])
        let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名称
        let fileName = disposition.substring(disposition.indexOf('fileName=') + 22, disposition.length)
        let text = fileName
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = text.substring(0, text.length - 1)
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    // 添加时间改变处理方法
    handleDateChange (dates) {
      if (dates.length === 2) {
        this.search.createTimeBegin = dates[0] + ' 00:00:00'
        this.search.createTimeEnd = dates[1] + ' 23:59:59'
      } else {
        this.search.createTimeBegin = ''
        this.search.createTimeEnd = ''
      }
    },
    // 重置搜索条件
    resetSearch () {
      this.dateRange = []
      this.search = {
        nickname: '',
        phone: '',
        id: '',
        pageNo: 1,
        pageSize: 10,
        orderNum: '',
        createTimeBegin: '',
        createTimeEnd: ''
      }
      this.getTableList()
    },
    /**
     * 获取代理类型文本
     */
    getAgentTypeText (agentType) {
      const typeMap = {
        '5': '地推',
        '1': '自主推广',
        '2': '推广服务商',
        '3': '区域合伙人',
        '4': '城市代理'
      }
      return typeMap[agentType] || '无'
    },

    /**
     * 显示代理类型修改模态框
     */
    showAgentTypeModal (row) {
      this.agentTypeForm.id = row.id
      this.agentTypeForm.agentType = row.agentType
      this.diyDom.showAgentTypeModal = true
    },

    /**
     * 保存代理类型修改
     */
    saveAgentType () {
      if (!this.agentTypeForm.agentType) {
        this.$Message.error('请选择代理类型')
        return
      }

      apiUpdateAgentType(this.agentTypeForm).then(res => {
        if (res.code === 200) {
          this.$Message.success('修改成功')
          this.diyDom.showAgentTypeModal = false
          this.getTableList() // 刷新列表
        } else {
          this.$Message.error(res.msg || '修改失败')
        }
      }).catch(err => {
        this.$Message.error('修改失败: ' + err.message)
      })

      // 由于没有提供实际的API，这里只是演示逻辑
      this.$Message.success('修改成功')
      this.diyDom.showAgentTypeModal = false
      this.getTableList() // 刷新列表
    },

    /**
     * 取消代理类型修改
     */
    cancelAgentType () {
      this.diyDom.showAgentTypeModal = false
    },

    /**
     * 处理排序变化
     */
    handleSortChange (sortInfo) {
      if (sortInfo.key === 'referrerTotal') {
        sortInfo.key = 't.referrer_lv1'
      }
      // 如果有排序信息，则添加到搜索条件中
      if (sortInfo.key && sortInfo.order) {
        this.search.sortField = sortInfo.key
        this.search.sortOrder = sortInfo.order === 'asc' ? 'asc' : 'desc'
      } else {
        // 如果没有排序信息，则删除排序条件
        delete this.search.sortField
        delete this.search.sortOrder
      }
      this.search.pageNo = 1
      this.getTableList()
    }
  },
  mounted () {
    var search = sessionStorage.getItem('search') || ''
    if (search) {
      this.search = JSON.parse(search)
      sessionStorage.removeItem('search')
    }
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;

}
</style>
